import React, { useEffect, useState, useRef } from "react";
import Swal2 from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import "../styles/payments.css";
import Loading from "../helpers/loading_component.js";
import emailjs from "@emailjs/browser";
import LoadingPopup from "../helpers/loading_component.js";

const MySwal = withReactContent(Swal2);

const ClientContactData = (props) => {
  const [contact, setContact] = useState("");

  useEffect(() => {
    var contactA = props.contactsData.filter(
      (el) => +el.id === +props.contactId
    )[0];
    setContact(contactA);

    props.logClientAction(
      "Otwarto kartę kontaktu: " + contactA.type,
      contactA.clientId
    );
  }, []);

  return (
    <div className="mainContainerClientContact">
      <>
        <div className="closeBox">
          <button className="closeClientButton" onClick={props.close}>
            X
          </button>
        </div>
        <div className="clientContactTitle">
          Szczegóły kontaktu - {props.clientName}
        </div>
        <div className="clientContactData">
          <p>
            Data:{" "}
            {new Date(contact.date).getFullYear() +
              "-" +
              (new Date(contact.date).getMonth() + 1 < 10
                ? "0" + (new Date(contact.date).getMonth() + 1)
                : new Date(contact.date).getMonth() + 1) +
              "-" +
              (new Date(contact.date).getDate() < 10
                ? "0" + new Date(contact.date).getDate()
                : new Date(contact.date).getDate())}
          </p>
          <p>RODZAJ: {contact.type}</p>
        </div>
        <div className="clientContactContent">
          <p>Treść kontaktu:</p>
          <p style={{ fontWeight: "300", textTransform: "default" }}>
            {contact.content}
          </p>
        </div>
      </>
    </div>
  );
};

export default ClientContactData;
